// LocalStorage utilities for React web app
export const storeData = async (data, token, login) => {
  try {
    localStorage.setItem("data", JSON.stringify(data));
    localStorage.setItem("token", JSON.stringify(token));
    localStorage.setItem("login", JSON.stringify(login));
    return true;
  } catch (error) {
    console.error('Storage error:', error);
    return false;
  }
};

export const getData = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error('Get data error:', error);
    return null;
  }
};

export const removeData = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    console.error('Remove data error:', error);
    return false;
  }
};

export const clearAllData = () => {
  try {
    localStorage.clear();
    return true;
  } catch (error) {
    console.error('Clear data error:', error);
    return false;
  }
};